import constant from '../../store/constant'
import config from '../../store/config'
var utils = require('../../utils')

export default {
  name: 'facility-detail',
  data: function () {
    return {
      shopId: null,
      facilityId: null,
      facility: null,
      facilityHisId: null,
      isNoneData: false,
      notifyData: null,
      facility_pay: null,
      // ログインID先頭文字
      login_id_prefix: null,
      searchCallbackFlag: false, // 検索結果フラグ
      // 表示モード
      isFacility: true,       // 施設
      isFacilityPerson: false, // 個人宅
      /** 画像タイトル編集 */
      editImageTitle: null
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.googleMapEventRemove() // google map イベント削除
    next()
  },
  created: function() {
    if (this.$route.name === 'facilityDetail') {
      this.isFacility = true
      this.isFacilityPerson = false
    } else if (this.$route.name === 'facilityPersonDetail') {
      this.isFacility = false
      this.isFacilityPerson = true
    }

    // システム管理者 または 薬剤師
    this.$store.dispatch('USER_ADMIN_PHARMACIST')

    if (this.$store.getters.canManage) {
      // 店舗ID
      this.shopId = this.$store.getters.currentShopId
    }
    // this.$store.dispatch('SHOP_SEARCH')
    this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})
    // ログインID先頭文字
    this.login_id_prefix = constant.facility.login_id_prefix

    if (this.$router.currentRoute.query.keep !== 'true') {
      this.facilityClear()
      if (this.$route.params.facilityId !== undefined) {
        this.facilityId = this.$route.params.facilityId
      } else {
        this.goPrev()
      }
      this.search(false)
    }
    else {
      if (this.$store.getters.facilitiesSearchParams) {
        this.shopId = this.$store.getters.facilitiesSearchParams['shop_id']
        this.facilityId = this.$store.getters.facilitiesSearchParams['facility_id']
      }
    }
  },
  computed: {
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    /** 認証情報のみ */
    facilityDetailAuth() {
      return this.$store.getters.facilityDetailAuth
    },
    /** 施設履歴 */
    facilityHistories() {
      return this.$store.getters.facilityDetailHistorys
    },
    /** 画像 */
    facilityImages() {
      return this.$store.getters.facilityImages
    },
    uploadCounter () {
      var total = this.$store.getters.imageUploadTotal
      var current = this.$store.getters.imageUploadCurrent
      if (total < 1 || total === current) {
        return ''
      } else {
        return this.$t('Count', {'Count': current + '/' + total}) + this.$t('Image Upload Successful')
      }
    },
    uploadErrors () {
      return this.$store.getters.imageUploadErrors
    },
    uploadSuccess () {
      return this.$store.getters.imageUploadStatus
    },
    /** 画像登録ボタン 押下可否 */
    canAddImage: function () {
      if (this.facilityImages !== null) {
        return this.facilityImages.length < constant.place_image_upload_limit
      } else {
        return true
      }
    },
    /** 管理者 または 組織長かつ薬剤師 */
    isAdminOrPharmacistManager() {
      return this.$store.getters.userAdminOrPharmacistManager
    },
    /** ローディング */
    loading() {
      return this.$store.getters.apiLoading
    },
    /** 通知 */
    notify() {
      if (this.notifyData !== null) {
        return this.notifyData
      }
      if (this.$store.getters.facilityDetailNotify !== null) {
        return this.$store.getters.facilityDetailNotify
      } else if (this.$store.getters.facilityEditNotify !== null) {
        return this.$store.getters.facilityEditNotify
      }
      return null
    },
    facilityPays() {
      let pays = constant.facility.pays.concat()

      for (let i in pays) {
        for (let j in this.facility.facility_pay) {
          if (pays[i].pay_code === this.facility.facility_pay[j].pay_code) {
            pays[i] = this.facility.facility_pay[j]
            break
          }
        }
      }

      return pays
    }
  },
  methods: {
    backToTop: function () {
      window.scrollTo(0, 0)
    },
    goFacilities: function () {
      this.$router.push({ path: '/facilities', query:{type: this.$router.currentRoute.query.type, keep: 'true'} })
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query:{type: this.$router.currentRoute.query.type} })
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query:{type: this.$router.currentRoute.query.type} })
    },
    goDoctors: function () {
      this.$router.push({ path: '/doctors', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareOffices: function () {
      this.$router.push({ path: '/care_offices', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query:{type: this.$router.currentRoute.query.type}})
    },

    /** 戻る */
    goPrev: function() {
      if (this.isFacility) {
        this.$router.push({path: '/facilities', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else if (this.isFacilityPerson) {
        this.$router.push({path: '/facility_persons', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      }
    },
    /** 編集画面 */
    goFacilityEdit: function () {
      if ((this.$route.params.facilityId !== undefined) && (this.facilityHisId !== null)) {
        if (this.isFacility) {
          this.$router.push({path: '/facilities/edit/'+ this.$route.params.facilityId + '/' + this.facilityHisId, query: {type: this.$router.currentRoute.query.type}})
        } else if (this.isFacilityPerson) {
          this.$router.push({path: '/facility_persons/edit/'+ this.$route.params.facilityId + '/' + this.facilityHisId, query: {type: this.$router.currentRoute.query.type}})
        }
      }
    },
    /** 検索 */
    search: function () {
      this.searchCallbackFlag = false
      var data = {
        'shop_id':     this.shopId,
        'facility_id': this.facilityId,
      }
      this.$store.dispatch('FACILITY_HISTORY_DETAIL_SEARCH', {data: data, callback: this.searchCallback})
    },
    /** 施設情報格納 */
    searchCallback: function (data) {
      if (utils.isBlank(data) || data.length <= 0) {
        this.goPrev()
        return
      }

      var exists = false
      for (var d of data) {
        if (d.attributes['current_flag']) {
          this.facility = d.attributes
          this.facilityHisId = d.attributes['facility_history_id']
          this.isNoneData = false
          exists = true
          break
        }
      }
      // 当日日付が見つからない場合先頭
      if (!exists) {
        if (data !== null && data.length > 0) {
          this.facility = data[0]
          this.facilityHisId = data[0].attributes['facility_history_id']
          this.isNoneData = false
        } else {
          this.isNoneData = true
        }
      }
      this.googleMapRender()
      this.searchCallbackFlag = true
    },
    /** グーグルマップを表示 */
    googleMapRender: function () {
      if (this.facility === null) {
        return
      }
      var address = ''
      if (utils.isPresent(this.facility.address1)) {
        address += this.facility.address1
      }
      if (utils.isPresent(this.facility.address2)) {
        address += this.facility.address2
      }
      var markaList = [{
        lat:     this.facility.map_lat,
        lng:     this.facility.map_lng,
        zoom:    this.facility.map_zoom,
        title:   this.facility.facility_name,
        address: address,
      }]
      // GoogleMaps
      utils.googleMapMarkaOnlyEvent({
        js:          constant.js.google_maps,
        key:         config.google_map_api_key,
        mapElmId:    'map',
        map_default: constant.map_default,
        markaList:   markaList,
      })
    },
    /** パラメータークリア */
    facilityClear: function () {
      this.facility = null
      this.facilityHisId = null
      this.$store.dispatch('FACILITY_HISTORY_DETAIL_CLEAR')
    },
    /** 日付文言取得 */
    getReferenceDate: function (d) {
      // 当日が含まれている場合
      if (d.attributes['current_flag']){
        return this.$t('history.today')
      }

      var start = utils.sereki2Wareki(this.$t, new Date(d.attributes['start_date']))
      var end = new Date(d.attributes['end_date'])
      if (end.getFullYear() === this.$t('history.max_year')) {
        end = this.$t('history.max_display')
      } else {
        end = utils.sereki2Wareki(this.$t, end)
      }
      return start + this.$t('history.delimiter') + end
    },
    /** 参照日付変更 */
    onChangeSelectDate: function () {
      for (var f of this.facilityHistories) {
        if (f.attributes['facility_history_id'] === this.facilityHisId) {
          this.facility = f.attributes
          this.googleMapRender()
          return
        }
      }
    },
    /** 店舗に対するコードを取得 */
    getFacilityCode: function (data) {
      var result = ''
      if ('facility_code' in data) {
        var code = data['facility_code']
        for (var i = 0; i < code.length; i++) {
          if (utils.str2int(code[i].shop_id)  === utils.str2int(this.shopId)) {
            result = code[i].code
            break
          }
        }
      }
      return result
    },
    /** 注意事項 削除/完了 */
    onClickFacilityNoticeModify: function (facility_notice_id, type) {
      var data = {
        'type':                type,
        'facility_notice_id':  facility_notice_id,
        'shop_id':             this.shopId,
        'facility_id':         this.facilityId,
        'facility_history_id': this.facilityHisId
      }
      this.$store.dispatch('FACILITY_HISTORY_DETAIL_NOTICE_MODIFY', {data: data, callback: this.noticeCallback})
    },
    /** 注意事項 完了 */
    noticeCallback: function (updateData) {
      this.facility = updateData.attributes
    },
    /** ログインID・パスワード通知PDF印刷 */
    onPrintNotifyPDF: function() {
      // 新規ウィンドウ
      var win = window.open(constant.html.loading)
      var data = {
        'shop_id':             this.shopId,
        'facility_id':         this.facilityId,
        'facility_history_id': this.facilityHisId
      }

      this.$store.dispatch('FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF', {data: data, callback:this.onPrintNotifyPDFCallback, win:win})
    },
    /** ログインID・パスワード通知PDF印刷印刷コールバック */
    onPrintNotifyPDFCallback: function(data, win) {
      win.location.href = data.download
      // 後始末
      setTimeout(() => {
        this.$store.dispatch('FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE', {data: {delete_path: data.delete_path}})
      }, constant.print_delete_time)
    },
    /** 報告書印刷 */
    onPrint: function() {
      // 新規ウィンドウ
      var win = window.open(constant.html.loading)
      var data = {
        'shop_id':             this.shopId,
        'facility_id':         this.facilityId,
        'facility_history_id': this.facilityHisId
      }
      this.$store.dispatch('FACILITY_HISTORY_DETAIL_PRINT', {data: data, callback:this.onPrintCallback, win:win})
    },
    /** 報告書印刷コールバック */
    onPrintCallback: function(data, win) {
      win.location.href = data.download
      // 後始末
      setTimeout(() => {
        this.$store.dispatch('FACILITY_HISTORY_DETAIL_PRINT_DELETE', {data: {delete_path: data.delete_path}})
      }, constant.print_delete_time)
    },

    /** 取引中止 */
    onStop: function(enable_flag) {
      var data = {
        'enable_flag':         enable_flag,
        'shop_id':             this.shopId,
        'facility_id':         this.facilityId,
        'facility_history_id': this.facilityHisId
      }
      this.$store.dispatch('FACILITY_HISTORY_DETAIL_STOP', {data: data, callback: this.facilityUpdateCallback})
    },

    /** ログイン・パスワード通知 */
    onSendMedinfo: function() {
      if (this.facility['send_type_2'] === 0 && this.facility['send_type_4'] === 0) {
        // 通知
        this.notifyData = {
          danger: true,
          message_i18n: 'messages.send_medinfo.mail_fax_none_setting'
        }
        setTimeout(() => {
          this.notifyData = null
        }, constant.notifyShowTime.normal)
        return
      }

      var data = {
        'shop_id':             this.shopId,
        'facility_id':         this.facilityId,
        'facility_history_id': this.facilityHisId
      }
      this.$store.dispatch('FACILITY_HISTORY_DETAIL_SEND_MEDINFO', {data: data, callback: this.facilityUpdateCallback})
    },

    /** 削除 */
    onClickDelete: function() {
      var self = this
      var callback = function () {
        self.facilityClear()
        self.search()
      }
      this.$store.dispatch('FACILITY_HISTORY_DETAIL_DELETE', {historyId: this.facilityHisId, callback: callback})
    },

    /** 画像押下 */
    onClickImageModalShow: function (image) {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = image.image_path + '?token=' + this.authToken
      text.textContent = image.title
      button.click() // モーダル表示 イベント発火
    },

    /** 画像タイトルリンク押下 */
    onClickTitleEditModalShow: function (image) {
      this.selectedImage = image
      this.editImageTitle = image.title
      this.$refs.editTitleBtn.click()
    },

    saveTitle: function () {
      this.selectedImage.title = this.editImageTitle
    },

    /** 画像登録ボタン 押下 */
    onClickUploadModalShow: function () {
      if (this.canAddImage) {
        var button = document.getElementById('images_upload_modal_button')
        button.click() // モーダル表示 イベント発火
        this.uploadStart()
      }
    },

    uploadStart: function () {
      this.$store.dispatch('IMAGE_UPLOAD_START')
    },

    upload: function (files) {
      if (!files)
        return
      if (!this.canAddImage)
        return
      for (var i=0; i<files.length; i++) {
        var formData = new FormData()
        formData.append('image_attach[cache_id]', files[i])
        this.$store.dispatch('IMAGE_UPLOAD', { data: formData, callback: this.onUpload })
      }
    },
    onUpload: function (data) {
      var img = {}
      img.id              = null
      img.title           = data.title
      img.image_attach_id = null
      img.cache_id        = data.cache_id
      img.cache_id_cache  = data.cache_id_cache
      img.image_path      = data.image_path
      img.del_flag        = constant.facility.del_flag.off
      this.facilityImages.push(img)
    },
    onDragOver: function (event) {
      var files = event.dataTransfer.items
      if (files && (!this.canAddImage)) {
        event.dataTransfer.dropEffect = "none"
      }
      event.preventDefault()
    },
    onDrop: function (event) {
      // ブラウザ上でファイルを展開する挙動を抑止
      event.preventDefault()

      // ドロップされたファイルのfilesプロパティを参照
      if (this.canAddImage) {
        var files = event.dataTransfer.files
        this.upload(files)
      }
    },
    onFileChange: function (event) {
      // ドロップされたファイルのfilesプロパティを参照
      var files = event.target.files
      this.upload(files)
    },

    removeImage: function (image) {
      if (image) image.del_flag = constant.facility.del_flag.on // 1
    },

    onClickSave: function () {
      var data = {
        facility_history_id:this.facilityHisId,
        facility_id:        this.facilityId,
        images:             this.facilityImages
      }
      this.$store.dispatch('FACILITY_HISTORY_IMAGE_SAVE', {data: data, callback: this.onSaved})
    },
    onSaved: function () {
      this.$router.push({path: '/facilities/detail/' + this.$route.params.facilityId, query: {type: this.$router.currentRoute.query.type}})
    },
    /** 現在の内容を最新化 */
    facilityUpdateCallback: function() {
      for (var i = 0; i < this.facilityHistories.length; i++) {
        var d = this.facilityHistories[i].attributes
        if (parseInt(d.facility_history_id, 10) === parseInt(this.facilityHisId, 10)) {
          this.facility = this.facilityHistories[i].attributes
          break
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/facility-detail.js